import axios from "axios";
import { useState } from "react";
import Button from "../Button";
import Input from "../Input";

const CouponForm = ({ onChange = () => {}, office, ...props }) => {

    const [code, setCode] = useState('');
    const [coupon, setCoupon] = useState(null);

    const getCouponIdByCode = async () => {
        if (code) {
            try {
                const response = await axios.get(route('api.coupons.get-by-code', {code, office}));
                const coupon = response.data?.coupon;

                setCoupon(coupon)
                onChange && onChange(coupon)
            } catch (error) {}
        }
    }

    const handleChange = (event) => {
        setCode(event.target.value);
    }

    return (
        <div {...props}>
            <h2 className="text-xl mb-4">Cupón de descuento</h2>
            <div>
                {coupon ? (
                    <>
                        <h4>{coupon.name}</h4>
                    </>
                ) : (
                    <>
                        <Input
                            type="text"
                            value={code}
                            className="block w-full mb-2"
                            handleChange={handleChange}
                        />

                        <Button type="button" onClick={getCouponIdByCode}>Cobrar</Button>
                    </>
                )}
            </div>
        </div>
    )
}

export default CouponForm